// 9fbef606107a605d69c0edbcd8029e5d
import logger from '@tcp/core/src/utils/loggerInstance';
import isEmpty from 'lodash/isEmpty';
import { addAnalyticsValueToSessionStorage } from '@tcp/core/src/utils';

const FILE_NAME = 'ProductGridItem.utils';

/* getTopBadge  */
export const getTopBadge = (isMatchingFamily, badge1) => {
  return isMatchingFamily && badge1 && badge1.matchBadge
    ? badge1 && badge1.matchBadge
    : badge1 && badge1.defaultBadge;
};

/* Returns top rated badge if is on PLP page or is from PLP Page and top rated badge present else returns null */
export const getTopRatedBadge = (badge1, isFromPLPPage, categoryIdToCheck) => {
  if (isFromPLPPage && badge1 && badge1.topRatedBadge) {
    try {
      const categoriesString = badge1.topRatedBadge.categories;
      const replacedCategoriesString = categoriesString.replace(/'/g, '"');
      const categoriesObject = JSON.parse(replacedCategoriesString);
      return categoriesObject[categoryIdToCheck] || false;
    } catch (e) {
      logger.error({
        error: e,
        extraData: {
          title: 'An error occurred while parsing the top rated badge categories response',
          componentName: FILE_NAME,
          methodName: 'getTopRatedBadge',
          badge1,
          isFromPLPPage,
          categoryIdToCheck,
        },
      });
      return null;
    }
  }
  return null;
};

export const getBestSellerBadge = (badge1, isFromPLPPage, categoryIdToCheck) => {
  if (isFromPLPPage && badge1 && badge1.isBestSeller) {
    try {
      const categoriesString = badge1?.isBestSeller?.categories;
      const replacedCategoriesString = categoriesString.replace(/'/g, '"');
      const categoriesObject = JSON.parse(replacedCategoriesString);
      return categoriesObject[categoryIdToCheck] || false;
    } catch (e) {
      logger.error({
        error: e,
        extraData: {
          title: 'An error occurred while parsing the best seller badge categories response',
          componentName: FILE_NAME,
          methodName: 'getBestSellerBadge',
          badge1,
          isFromPLPPage,
          categoryIdToCheck,
        },
      });
      return null;
    }
  }
  return null;
};
export const getMostFavoriteBadge = (badge1, isFromPLPPage, categoryIdToCheck) => {
  if (isFromPLPPage && badge1 && badge1.mostFavoritedBadge) {
    try {
      const categoriesString = badge1?.mostFavoritedBadge?.categories;
      const replacedCategoriesString = categoriesString.replace(/'/g, '"');
      const categoriesObject = JSON.parse(replacedCategoriesString);
      return categoriesObject[categoryIdToCheck] || false;
    } catch (e) {
      logger.error({
        error: e,
        extraData: {
          title: 'An error occurred while parsing the most favorited badge categories response',
          componentName: FILE_NAME,
          methodName: 'getMostFavoriteBadge',
          badge1,
          isFromPLPPage,
          categoryIdToCheck,
        },
      });
      return null;
    }
  }
  return null;
};

/* get video url */
export const getVideoUrl = (curentColorEntry) => {
  return curentColorEntry && Array.isArray(curentColorEntry.miscInfo?.videoUrl)
    ? curentColorEntry.miscInfo.videoUrl[0]
    : '';
};

export const getPayloadForOneClickATC = ({
  name,
  isGiftCard,
  parsedVariantDetails,
  basicImageUrl,
  seoToken,
  productId,
  TCPStyleType,
  TCPStyleQTY,
  listPrice,
  offerPrice,
  TCPWebOnlyFlagStore,
  TCPProductIndStore,
  prodPartNo,
  brand,
  topBadge,
  bossDisabledFlags,
  colorName,
}) => {
  const { UPC_ID, size } = parsedVariantDetails || {};
  return {
    isGiftCard,
    productName: name,
    skuInfo: {
      imageUrl: basicImageUrl,
      color: { name: colorName },
      variantId: UPC_ID,
      productId,
      seoToken,
      size,
      fit: null,
      TCPStyleType,
      TCPStyleQTY,
      listPrice,
      offerPrice,
      TCPWebOnlyFlagStore,
      TCPProductIndStore,
      prodPartNo,
    },
    fromPage: 'search',
    originPage: 'slp',
    brand,
    quantity: 1,
    isOnlineExclusive: topBadge || null,
    bossDisabledFlags,
  };
};

export const hideProductOriginalPrice = (isHardMarkDown, killSwitch) => {
  return !isEmpty(isHardMarkDown) && killSwitch;
};

export const getOriginalPrice = ({
  hardMarkDown,
  isHideOriginalPriceAndMarchantTagEnabled,
  listPrice,
  currency,
  addWhiteSpace,
  fromAddedToCart,
  prodPartNo,
  fixedPrice,
}) => {
  const hideOriginalPrice = hideProductOriginalPrice(
    hardMarkDown,
    isHideOriginalPriceAndMarchantTagEnabled
  );

  const space = addWhiteSpace ? ' ' : '';

  const finalListPrice = fixedPrice ? listPrice?.toFixed(2) : listPrice;

  if (hideOriginalPrice) {
    const value = 'hide';
    if (fromAddedToCart && prodPartNo) {
      addAnalyticsValueToSessionStorage({ key: 'hardPriceMarkDown', prodPartNo, value });
    }
    return value;
  }

  return `${finalListPrice}${space}${currency}`;
};
